export default __webpack_public_path__ + "static/media/loader-logo.b6322f29.png";